var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12",
            md: "6"
          }
        },
        [
          _c(
            "gg-card-title",
            {
              staticClass: "pb-0 pt-0"
            },
            [_vm._v(_vm._s(_vm.$route.meta.pageTitle))]
          )
        ],
        1
      ),
      _c(
        "v-col",
        {
          staticClass: "text-md-right pb-2",
          attrs: {
            cols: "12",
            md: "6"
          }
        },
        [_c("add-new-account")],
        1
      ),
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c("services-table", {
            attrs: {
              title: "Hosting Plans",
              items: _vm.allServicesList,
              filters: _vm.filters,
              search: _vm.search
            },
            scopedSlots: _vm._u([
              {
                key: "header-actions",
                fn: function fn() {
                  return [
                    _c("g-g-filter", {
                      attrs: {
                        "offset-y": "",
                        left: "",
                        bottom: "",
                        "close-on-content-click": false,
                        items: _vm.filterItems
                      },
                      on: {
                        change: function change($event) {
                          _vm.filters = $event
                        }
                      }
                    }),
                    _c(
                      "div",
                      {
                        staticClass: "w-100",
                        staticStyle: {
                          "max-width": "440px"
                        }
                      },
                      [
                        _c("services-search", {
                          attrs: {
                            compact: ""
                          },
                          model: {
                            value: _vm.search,
                            callback: function callback($$v) {
                              _vm.search = $$v
                            },
                            expression: "search"
                          }
                        })
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c("services-table", {
            attrs: {
              title: "Shared With Me",
              items: _vm.sharedServicesList,
              text: "",
              search: _vm.search,
              "hide-icons": ""
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }